// react
import React from "react"
// material-ui
import { Card, CardHeader, CardActions, CardText } from "material-ui/Card"
import FlatButton from "material-ui/FlatButton"
// app
import TextField from "components/common/TextField"
import SelectField, { Style } from "containers/SelectField"


const initialState = {
    firstname_error: true,
    lastname_error: true,
    email_error: true,
    type: ""
}

class NewPerson extends React.Component {
    constructor(props) {
        super(props)
        this.state = initialState

        this.setFirstname = (firstname) => this.setState({ firstname })
        this.errorFirstname = (firstname_error) => this.setState({ firstname_error })
        this.setLastname = (lastname) => this.setState({ lastname })
        this.errorLastname = (lastname_error) => this.setState({ lastname_error })
        this.setEmail = (email) => this.setState({ email })
        this.errorEmail = (email_error) => this.setState({ email_error })
        this.setType = type => this.setState({ type })

        this.save = this.save.bind(this)
    }

    save() {
        const { firstname, lastname, email, type } = this.state

        this.props.onSave({
            firstname, lastname, email, type
        })
    }

    render() {
        return (
            <Card className="card">
                <CardHeader title="Create new profile" />
                <CardText className="clearfix">
                    <div className="float-left">
                        <TextField
                            autoFocus={ true }
                            label="Firstname"
                            mandatory={ true }
                            onChange={ this.setFirstname }
                            onError={ this.errorFirstname }
                        />
                        <br />
                        <TextField
                            label="Lastname"
                            mandatory={ true }
                            onChange={ this.setLastname }
                            onError={ this.errorLastname }
                        />
                        <br />
                        <TextField
                            label="Email"
                            mandatory={ true }
                            onChange={ this.setEmail }
                            onError={ this.errorEmail }
                        />
                        <br />
                        <SelectField
                            table="type"
                            label="Profile Type"
                            mandatory={ true }
                            style={ Style.ValueOnly }
                            onChange={ this.setType }
                        />
                    </div>
                </CardText>
                <CardActions>
                    <FlatButton
                        label="Create"
                        primary={ true }
                        disabled={
                            this.state.firstname_error ||
                            this.state.lastname_error ||
                            this.state.email_error ||
                            this.state.type === ""
                        }
                        onClick={ this.save }
                    />
                </CardActions>
            </Card>
        )
    }
}

export default NewPerson


/** WEBPACK FOOTER **
 ** ./src/components/person/NewPerson/new-person.js
 **/